module.exports = __webpack_public_path__ + "static/img/Application.38f2fdc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobizone/imgs/browse/Application.jpg
// module id = 1557
// module chunks = 0